
export default function BenefitsSection() {
  const benefits = [
    {
      icon: 'ri-user-smile-line',
      title: 'Simple for everyone',
      description: 'Intuitive design that makes managing crypto easy, whether you\'re a beginner or experienced user.',
    },
    {
      icon: 'ri-key-2-line',
      title: 'Your keys, your crypto',
      description: 'Non-custodial wallet means you have full control. We never have access to your funds.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Secure by design',
      description: 'Biometric authentication, encrypted storage, and industry-leading security practices.',
    },
    {
      icon: 'ri-coin-line',
      title: 'Multi-asset ready',
      description: 'Support for Bitcoin, Ethereum, and popular tokens. More assets added regularly.',
    },
  ];

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Why Vollet?</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Built for simplicity, designed for security. Here's what makes Vollet different.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-2xl p-6 lg:p-8 hover:shadow-lg transition-shadow cursor-pointer group"
            >
              <div className="w-14 h-14 bg-[#4C6FFF]/10 rounded-xl flex items-center justify-center mb-5 group-hover:bg-[#4C6FFF]/20 transition-colors">
                <i className={`${benefit.icon} text-2xl text-[#4C6FFF]`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
